export function getUserInitial(user) {
  const name = String(user?.name || '').trim();
  if (name) {
    return name.charAt(0).toUpperCase();
  }

  const email = String(user?.email || '').trim();
  if (email) {
    return email.charAt(0).toUpperCase();
  }

  return '?';
}

export function getRoleDisplayName(role) {
  const normalizedRole = String(role || '').trim().toLowerCase();

  if (!normalizedRole) {
    return 'User';
  }

  if (normalizedRole === 'shop_admin') {
    return 'Admin';
  }

  return normalizedRole
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getRoleDisplayNameLocalized(role, t) {
  const normalizedRole = String(role || '').trim().toLowerCase();

  if (!normalizedRole) {
    return t ? t('admin.user_fallback') : 'User';
  }

  const roleKeyMap = {
    shop_admin: 'admin.role_shop_admin',
    barber: 'admin.role_barber',
    superadmin: 'admin.role_superadmin',
    user: 'admin.user_fallback'
  };

  const key = roleKeyMap[normalizedRole];
  if (t && key) {
    return t(key);
  }

  return getRoleDisplayName(role);
}
